import React, {useState, useEffect} from 'react';

const FormSubmissionPostSubmitJavascript = ({value, onChange}) => {

  const [model, setModel] = useState(value || {});

  useEffect(() => onChange(model.enabled && model.javascript ? model : {}), [model]);

  if (!model.enabled) {
    return <></>;
  }
  return <div className="my-3">
    <label htmlFor="postSubmitJsCode" className="form-label">Javascript code run after submission</label>
    <textarea id="postSubmitJsCode"
              className="form-control"
              style={{minHeight: '10em'}}
              value={model.javascript || ''}
              onChange={e => setModel('javascript', e.target.value)} />
    <div className="form-text">Note: this field is deprecated, please refer to the note for developers below for an alternative.</div>
  </div>;
};

export default FormSubmissionPostSubmitJavascript;
